export default {
  name: 'Storyboard',
  path: '/projects/:projectId/storyboard',
  meta: {
    title: 'router.storyboard'
  }
};